// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__NgsA0","rootSuccess":"CompleteLink_rootSuccess__1Fn29","rootFailure":"CompleteLink_rootFailure__302M1","isDisabled":"CompleteLink_isDisabled__31FdY"};